import classes from "./Header.module.css";
import { Link, NavLink } from "react-router-dom";
import { UserContext } from "../contexts/AuthContext";
import { useContext } from "react";
import logo from "./../assets/logo.png"
const Header = () => {
  const {isAuthenticated, handleMenu, token } = useContext(UserContext);
  console.log("Component rendered - isAuthenticated:", isAuthenticated, "token:", token);

  return (
    <>
      <header className={classes.header}>
        <div className={classes.logoWrapper}>
          <NavLink to={"/dashboard"} onClick={handleMenu}><img src={logo} /></NavLink>
        </div>
        <div className={classes.navWrapper}>
          <ul>
            <li className={classes.navItem}>
                <div onClick={()=> {handleMenu()}} className={classes.burgerMenu}>
                  <div></div>
                </div>
            </li>
          </ul>
        </div>
      </header>
    </>
  );
};
export default Header;
